<template>
  <div class="results">
    <div class="bg-white text-default">
      <div class="">
        <h2 class="text-align--center" v-if="headline && Object.keys(events).length">{{ headline }}</h2>
        <div v-for="(event, eventCount) in events" :key="'eventresults-' + event.wigeEventId">
          <div class="results__fold margin--top-1"
               :class="{ 'view': event.opened }"
               @click="event.opened = !event.opened">
            <div class="row">
              <div class="col">
                <span class="text-primary">{{ ('00' + eventCount).slice(-2) }}</span>
                {{ event.wigeName }}
              </div>
              <div class="col-auto position-relative">
                <svg class="results__fold__icon svg-fill-white" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"><g id="arrow" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Icon-24px" transform="translate(8.000000, 5.500000)"><polygon id="Shape" points="7.41 11.09 2.83 6.5 7.41 1.91 6 0.5 0 6.5 6 12.5"></polygon></g></g></svg>
              </div>
            </div>
          </div>
          <div class="results__content" :class="{ 'view': event.opened }">
            <div class="row no-gutters padding--bottom-2 padding--top-2">
              <div class="col-auto position-relative results__select">
                <select v-model="event.activeSession">
                  <template v-for="session in event.sessions">
                    <option v-if="session.result"
                            :key="'sess-' + event.wigeEventId + '-' + session.sessionid"
                            :value="session.sessionid">{{ session.name }}</option>
                  </template>
                </select>
                <svg class="results__select__icon" fill="fill-bg" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"><g id="arrow" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Icon-24px" transform="translate(8.000000, 5.500000)"><polygon id="Shape" points="7.41 11.09 2.83 6.5 7.41 1.91 6 0.5 0 6.5 6 12.5"></polygon></g></g></svg>
              </div>
            </div>
            <template v-for="session in event.sessions">
              <div v-if="session.result && event.activeSession === session.sessionid"
                   class="padding--bottom-3"
                   :key="'sess-table-' + event.wigeEventId + '-' + session.sessionid">
                <table width="100%" class="timing-results d-md-none">
                  <tbody>
                    <template v-for="(row, rowIndex) in session.result">
                      <tr :key="'sess-row-' + event.wigeEventId + '-' + session.sessionid + '-' + row.id" v-if="session.resultOpen || (!session.resultOpen && rowIndex < 5)">
                        <td rowspan="2" class="font-weight--bold text-align--center td-position"
                            :class="{ 'bg-primary': row.position === '1', 'bg-medium': row.position === '2' || row.position === '3', 'bg-light': parseInt(row.position) > 3 }">{{ ('0' + row.position).slice(-2) }}</td>
                        <td class="padding-off" width="60"><img
                          :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].image ? `https://media.graphcms.com/resize=w:120,fit:crop/quality=value:70/compress/${drivers[event.year + '-' + row.number].image.handle}` : pixel"
                          width="60"
                          :alt="row.name"
                        ></td>
                        <td class="text-align--center padding-right-off">
                          <img :src="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country && drivers[event.year + '-' + row.number].country.appCountryFlag ? drivers[event.year + '-' + row.number].country.appCountryFlag.url : pixel)"
                               width="16" height="16"
                               :title="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')"
                               :alt="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')">
                        </td>
                        <!-- TODO add additional ranking field here -->
                        <td :colspan="session.type === 'qualifying' ? 1 : 2" class="padding-right text-uppercase" v-html="(drivers[event.year + '-' + row.number] ? drivers[event.year + '-' + row.number].firstName + ' <b>' + drivers[event.year + '-' + row.number].lastName + '</b>' : row.firstName + ' <b>' + row.lastName + '</b>') + '<br/><span class=\'font-small text-condensed\'>' + row.team + '</span>'"></td>
                      </tr>
                      <tr :key="'sess-row-' + event.wigeEventId + '-' + session.sessionid + '--' + row.id" v-if="session.resultOpen || (!session.resultOpen && rowIndex < 5)">
                        <td v-if="session.type === 'race'" class="no-border" colspan="2">
                          <b class="text-uppercase text-condensed"><i>{{ $t('results.time') }}</i></b>
                          <div>{{ row.status !== '' ? row.status : row.position === '1' ? row.time : row.gap.indexOf('L') > -1 ? row.gap : '+' + row.gap }}</div>
                        </td>
                        <td class="no-border va-top" :colspan="session.type === 'race' ? 1 : 2">
                          <b class="text-uppercase text-condensed"><i>{{ session.type === 'race' ? $t('results.fastest_lap') : $t('results.time') }}</i></b>
                          <div>{{ row.fastestlap }}</div>
                        </td>
                        <td v-if="session.type === 'qualifying'" class="no-border va-top">
                          <b class="text-uppercase text-condensed"><i>{{ $t('results.interval') }}</i></b>
                          <div>{{ row.int }}</div>
                        </td>
                        <td v-if="session.type === 'training'" class="no-border padding-left-off va-top text-align--center">
                          <b class="text-uppercase text-condensed"><i>{{ $t('results.gap') }}</i></b>
                          <div v-html="row.gap ? row.gap : '&nbsp;'"></div>
                        </td>
                        <td v-if="session.type === 'race'" class="no-border padding-left-off va-top text-align--right">
                          <b class="text-uppercase text-condensed"><i>{{ $t('results.points') }}</i></b>
                          <div :class="{ 'font-weight--bold': row.status === '' }" v-html="row.status !== '' ? row.status : row.points"></div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="d-md-none padding--bottom-2">
                  <button class="button-primary button-primary--to-dark w-100" v-if="!session.resultOpen" @click="session.resultOpen = true">more</button>
                </div>
                <table width="100%" class="timing-results d-none d-md-table">
                  <thead>
                  <tr>
                    <th class="text-condensed" width="60">{{ $t('results.position') }}</th>
                    <th class="text-condensed d-none d-lg-table-cell"></th>
                    <th class="text-condensed" width="40"></th>
                    <th class="text-condensed tl padding-left-off">{{ $t('results.driver') }} / {{ $t('results.team') }}</th>
                    <th class="text-condensed d-none d-lg-table-cell">{{ $t('results.manufacturer') }}</th>
                    <th class="text-condensed" v-if="session.type === 'race'">{{ $t('results.time') }}</th>
                    <th class="text-condensed">{{ $t('results.fastest_lap') }}</th>
                    <th class="text-condensed" v-if="session.type === 'race'">{{ $t('results.pitstops') }}</th>
                    <th class="text-condensed" v-if="session.type === 'qualifying'">{{ $t('results.interval') }}</th>
                    <th class="text-condensed" v-if="session.type === 'training'">{{ $t('results.gap') }}</th>
                    <th class="text-condensed" v-if="session.type === 'training'">{{ $t('results.laps') }}</th>
                    <th class="text-condensed" v-if="session.type === 'race'">{{ $t('results.points') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in session.result" :key="'sess-row-' + event.wigeEventId + '-' + session.sessionid + '-' + row.id">
                    <td class="font-weight--bold text-align--center td-position"
                        :class="{ 'bg-primary': row.position === '1', 'bg-medium': row.position === '2' || row.position === '3', 'bg-light': parseInt(row.position) > 3 }">{{ ('0' + row.position).slice(-2) }}</td>
                    <td class="padding-off padding-right-off d-none d-lg-table-cell td-flag--tr" width="100"><img
                      :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].image ? `https://media.graphcms.com/resize=w:200,fit:crop/quality=value:70/compress/${drivers[event.year + '-' + row.number].image.handle}` : pixel"
                      width="80"
                      :alt="row.name"
                    ></td>
                    <td class="text-align--center">
                      <img :src="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country && drivers[event.year + '-' + row.number].country.appCountryFlag ? drivers[event.year + '-' + row.number].country.appCountryFlag.url : pixel)"
                           width="16" height="16"
                           :title="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')"
                           :alt="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')">
                    </td>
                    <td class="padding-right text-uppercase padding-left-off" v-html="(drivers[event.year + '-' + row.number] ? drivers[event.year + '-' + row.number].firstName + ' <b>' + drivers[event.year + '-' + row.number].lastName + '</b>' : row.firstName + ' <b>' + row.lastName + '</b>') + '<br/><span class=\'font-small text-condensed\'>' + row.team + '</span>'"></td>
                    <td class="d-none d-lg-table-cell text-align--center">
                      <img
                        :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].team && drivers[event.year + '-' + row.number].team.manufacturer && drivers[event.year + '-' + row.number].team.manufacturer.image ? drivers[event.year + '-' + row.number].team.manufacturer.image.url : pixel"
                        alt=""
                        class="imageLight"
                        width="60">
                      <img
                        :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].team && drivers[event.year + '-' + row.number].team.manufacturer && drivers[event.year + '-' + row.number].team.manufacturer.imageDark ? drivers[event.year + '-' + row.number].team.manufacturer.imageDark.url : pixel"
                        alt=""
                        class="imageDark"
                        width="60">
                    </td>
                    <td class="text-condensed text-align--center" v-if="session.type === 'race'">{{ row.status !== '' ? row.status : row.position === '1' ? row.time : row.gap.indexOf('L') > -1 ? row.gap : '+' + row.gap }}</td>
                    <td class="text-condensed text-align--center">{{ row.fastestlap }}</td>
                    <td class="text-condensed text-align--center" v-if="session.type === 'race'">{{ row.pitstops }}</td>
                    <td class="text-condensed text-align--center" v-if="session.type === 'qualifying'">{{ row.int }}</td>
                    <td class="text-condensed text-align--center" v-if="session.type === 'training'">{{ row.gap }}</td>
                    <td class="text-condensed text-align--center" v-if="session.type === 'training'">{{ row.laps }}</td>
                    <td class="text-align--center font-weight--bold" v-if="session.type === 'race'">{{ row.points }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'Results',
  props: {
    baseEvent: Object,
    raceSeries: String,
    settings: Object,
    headline: String
  },
  data () {
    return {
      loading: true,
      events: {},
      drivers: {},
      headlineVisible: false,
      page: {},
      pixel: AppConst.PIXEL,
      points: {
        race: [25, 18, 15, 12, 10, 8, 6, 4, 2, 1],
        qualifying: [3, 2, 1]
      }
    };
  },
  computed: {
    queryName: function () {
      return this.$store.getters['page/raceSeriesDrivers'];
    }
  },
  methods: {
    async fetchDrivers () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryName}`,
        lifetime: Settings.LIFETIME_DEFAULT
      }).then(response => {
        const drivers = {};
        response.drivers.forEach((driver) => {
          let age = 0;
          if (driver.appBirth) {
            const split = driver.appBirth.split('.');
            const birthDay = new Date(split[2], split[1] - 1, split[0]);
            const ageDifMs = Date.now() - birthDay.getTime();
            const ageDate = new Date(ageDifMs); // miliseconds from epoch
            age = Math.abs(ageDate.getUTCFullYear() - 1970);
          }
          driver.age = age;
          const year = driver.driverUniqueID.substr(-4);
          if ('teamTrophies' in driver && driver.teamTrophies.length) {
            driver.team = {
              manufacturer: driver.teamTrophies[0].manufacturerTrophy,
              name: driver.teamTrophies[0].name
            };
          }
          drivers[year + '-' + driver.driverNumber] = driver;
        });
        this.drivers = drivers;
      });
    },
    async fetchResults () {
      const now = new Date();
      let startDate = new Date(now.getFullYear() + '-01-01');
      let endDate = new Date(now.getFullYear() + '-12-31');
      let raceSeries = 'DTM';
      if (this.raceSeries) {
        raceSeries = this.raceSeries.toUpperCase();
      }
      if (this.baseEvent) {
        const startTime = new Date(this.baseEvent.startTime);
        const endTime = new Date(this.baseEvent.endTime);
        startDate = new Date(startTime.getFullYear() + '-' + (startTime.getMonth() + 1) + '-' + startTime.getDate());
        endDate = new Date(endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate());
      }
      if (this.settings && 'startDate' in this.settings && 'endDate' in this.settings) {
        startDate = new Date(this.settings.startDate);
        endDate = new Date(this.settings.endDate);
      }
      if (this.settings && 'raceSeries' in this.settings) {
        raceSeries = this.settings.raceSeries.toUpperCase();
      }
      const query = raceSeries === 'DTM' ? 'wigeResults' : 'wigeResultsTrophy';
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: 'data?query=' +
          query +
          '&raceSeries=' +
          raceSeries +
          '&startDate=' +
          (startDate.getFullYear() + '-' + ('00' + (startDate.getMonth() + 1)).slice(-2) + '-' + ('00' + startDate.getDate()).slice(-2)) +
          '&endDate=' +
          (endDate.getFullYear() + '-' + ('00' + (endDate.getMonth() + 1)).slice(-2) + '-' + ('00' + endDate.getDate()).slice(-2)),
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          const responseName = raceSeries === 'DTM' ? 'wigeResultses' : 'wigeResultsTrophies';
          if (responseName in response) {
            const events = {};
            const eventIds = [];
            response[responseName].forEach((row) => {
              let event = {};
              const json = JSON.parse(row.jsonText);
              if (!eventIds.includes(row.wigeEventId)) {
                eventIds.push(row.wigeEventId);
                const date = new Date(row.startDate);
                event.wigeEventId = row.wigeEventId;
                event.wigeName = row.wigeName;
                if (event.wigeName.substr(0, 1) === '(') {
                  event.wigeName = event.wigeName.substr(event.wigeName.indexOf(')') + 1).trim();
                }
                if (event.wigeName.indexOf('DTM') > -1) {
                  event.wigeName = event.wigeName.replace('DTM', '').trim();
                }
                event.startDate = row.startDate;
                event.endDate = row.endDate;
                event.sessions = json.sessions;
                event.type = row.type;
                event.year = date.getFullYear();
                event.activeSession = -1;
                event.opened = false;
                events[event.wigeEventId] = event;
              } else {
                event = events[row.wigeEventId];
              }
              event.sessions.forEach((session, sessionIndex) => {
                if (json && parseInt(session.sessionid) === parseInt(json.sessionid)) {
                  let currentPointValue = 0;
                  // set training to qualifying, if qualfying in session name
                  if (session.name.toLowerCase().indexOf('qualifying') > -1) {
                    session.type = 'qualifying';
                  }
                  if (session.type in this.points) {
                    json.result.forEach((resultRow, resultRowIndex) => {
                      // firstName, lastName
                      const name = json.result[resultRowIndex].name.split(' ');
                      json.result[resultRowIndex].firstName = '';
                      json.result[resultRowIndex].lastName = json.result[resultRowIndex].name;
                      if (name.length) {
                        json.result[resultRowIndex].firstName = name[name.length - 1];
                        // extra for Jan Philipp, Jose Maria
                        if (json.result[resultRowIndex].name.indexOf('Jan Philipp') > -1 || json.result[resultRowIndex].name.indexOf('Jose Maria') > -1) {
                          json.result[resultRowIndex].firstName = name[name.length - 2] + ' ' + name[name.length - 1];
                        }
                        json.result[resultRowIndex].lastName = json.result[resultRowIndex].name.substr(0, json.result[resultRowIndex].name.length - json.result[resultRowIndex].firstName.length).trim();
                      }
                      // calculate points, if no sessionpoints
                      if (!('sessionpoints' in json.result[resultRowIndex])) {
                        json.result[resultRowIndex].points = 0;
                        if (resultRow.status === '' && currentPointValue < this.points[session.type].length) {
                          json.result[resultRowIndex].points = this.points[session.type][currentPointValue];
                          currentPointValue++;
                        }
                      } else {
                        json.result[resultRowIndex].points = json.result[resultRowIndex].sessionpoints;
                      }
                    });
                  }
                  session.resultOpen = false;
                  session.result = json.result;
                  if (json.result && json.result.length && session.sessionid > event.activeSession) {
                    event.activeSession = session.sessionid;
                  }
                }
              });
            });
            const keys = Object.keys(events);
            if (keys.length === 1) {
              events[keys[0]].opened = true;
            } else if (keys.length > 1) {
              events[keys[keys.length - 1]].opened = true;
            }
            this.events = events;
          }
          this.loading = false;
        })
        .catch(() => {
          //
        });
    }
  },
  created () {
    this.fetchDrivers();
    this.fetchResults();
  },
  watch: {
    event: function (newVal, oldVal) {
      this.fetchResults();
    }
  }
};
</script>

<style lang="scss">
  .results {
    &__fold {
      $fold: &;
      position: relative;
      background: $color-bg;
      color: #fff;
      padding: $gap;
      font-weight: 600;
      text-transform: uppercase;
      transition: all .3s;
      font-size: 1.2em;
      cursor: pointer;
      &__icon {
        position: absolute;
        right: $gap;
        transform: rotate(-90deg);
        transition: all .4s $ease-out-back;
      }
      &:hover {
        background: $color-bg-light;
        #{$fold}__icon {
          transform: rotate(-270deg);
        }
      }
      &.view {
        #{$fold}__icon {
          transform: rotate(-270deg);
        }
      }
    }
    &__content {
      position: relative;
      overflow: hidden;
      max-height: 0;
      transition: all 1s $ease-out-cubic;
      &.view {
        transition: all 1s $ease-in-cubic;
        max-height: 5000px;
      }
    }
    &__select {
      &__icon {
        transform: rotate(270deg);
        position: absolute;
        top: 8px;
        right: 6px;
        color: #fff;
        z-index: 0;
      }
      select {
        cursor: pointer;
        position: relative;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        border: 1px solid $color-bg;
        padding: 10px $gap * 5 10px $gap;
        max-width: 100%;
        background: transparent;
        z-index: 1;
        color: $color-bg;
        text-transform: uppercase;
        &::-ms-expand {
          display: none;
        }
        &:focus {
          outline: none;
        }
        option {
          color: $color-bg;
        }
      }
    }
  }
</style>
